import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  TextField,
  Button,
  MenuItem,
  Grid,
  Box,
} from "@mui/material";
import ApiService from "../../Api/ApiController";
import Swal from "sweetalert2";

export default function CreateStock() {
  const [categories,setCategories] = useState([]);

  const [formData, setFormData] = useState({
    company_name: "",
    stock_category_id: "",
    symbol: "",
    change: "",
    price_change: "",
    current_price:"",
    direction:"",
  });

  const getCategory = ()=>{
    ApiService.getStockCategory().then((response)=>{
      if(response.data.status === true){
           setCategories(response.data.data)
      }else{
          setCategories([])
      }
    }).catch((error)=>{
      console.log(error)
      setCategories([])
    })
  }

  useEffect(()=>{
    getCategory()
  },[])
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Reset only for normal Submit (fresh entry)
  const resetForm = () => {
    setFormData({
      company_name: "",
      stock_category_id: "",
      change_price: "",
      quantity: "",
      change: "",
      current_price:"",
      direction:''
    });
  };

  const handleSubmit = (addMore = false) => {
    console.log("Form submitted:", formData);

    // TODO: API call here
    // axios.post("/api/stocks", formData)
    ApiService.createStocks(formData).then((response)=>{
      if(response.data.status === true){
           Swal.fire({
              toast: true,
              position: 'top-end', // You can change this to 'bottom-end', 'bottom-left', etc.
              icon: 'success',
              title: response.data.message,
              showConfirmButton: false,
              timer: 3000, // Duration in milliseconds
              timerProgressBar: true,
            });
      }else{
                Swal.fire({
                toast: true,
              position: 'top-end', // You can change this to 'bottom-end', 'bottom-left', etc.
              icon: 'error',
              title: addMore ? "Stock added! You can add another with same data." : "Stock created successfully!",
              showConfirmButton: false,
              timer: 3000, // Duration in milliseconds
              timerProgressBar: true,
            });
      }
    }).catch((error)=>{
      console.log(error)
    })

    if (addMore) {
    } else {
      resetForm();
    }
  };

  return (
    <Card sx={{ borderRadius: 3, boxShadow: 3, mt: 3 }}>
      <CardHeader
        title="Create Stock"
        titleTypographyProps={{ variant: "h6", fontWeight: "bold" }}
      />
      <CardContent>
        <Box component="form" noValidate autoComplete="off">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Stock Name"
                name="company_name"
                value={formData.company_name}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Symbol"
                name="symbol"
                value={formData.symbol}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Change"
                name="change"
                value={formData.change}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                select
                fullWidth
                label="Category"
                name="stock_category_id"
                value={formData.stock_category_id}
                onChange={handleChange}
              >
                {categories.map((cat) => (
                  <MenuItem key={cat._id} value={cat._id}>
                    {cat.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                type="number"
                label="Current Price"
                name="current_price"
                value={formData.current_price}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                type="number"
                label="Price Change"
                name="price_change"
                value={formData.price_change}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                select
                fullWidth
                label="Direction"
                name="direction"
                value={formData.direction}
                onChange={handleChange}
              >
                <MenuItem value="up">Up</MenuItem>
                <MenuItem value="down">Down</MenuItem>
              </TextField>
            </Grid>


            <Grid item xs={12} display="flex" justifyContent="flex-end" gap={2}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => handleSubmit(true)}
              >
                Submit & Add More
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => handleSubmit(false)}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </Box>
      </CardContent>
    </Card>
  );
}
